import React, { useState } from "react";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";

import { Box } from "@mui/material";
import Slider from "@mui/material/Slider";
import Typography from "@mui/material/Typography";

// Slider for High Cost Threshold

// <HighCostThresh  useOriginalThreshold={useOriginalThreshold} onCheckboxChange={onCheckboxChange} inputThreshold={inputThreshold} inputThresholdFormat={inputThresholdFormat} onThresholdChange={onThresholdChange} inputFWSpend={inputFWSpend} inputFWSpendFormat={inputFWSpendFormat}  onFWSpendChange={onFWSpendChange}  inputSatSpend={inputFWSpend} inputSatSpendFormat={inputFWSpendFormat} onSatSpendChange={onSatSpendChange}/>
function HighCostThresh({
  useOriginalThreshold,
  onCheckboxChange,
  inputThreshold,
  inputThresholdFormat,
  onThresholdChange,
  inputFWSpend,
  inputFWSpendFormat,
  onFWSpendChange,
  inputSatSpend,
  inputSatSpendFormat,
  onSatSpendChange
}) {
  const marks = [
    {
      value: 0,
      label: "0",
    },
    {
      value: 50000,
      label: "50,000",
    },
  ];

  const [isEditing, setIsEditing] = useState(false);
  const [isEditingFW, setIsEditingFW] = useState(false);
  const [isEditingSat, setIsEditingSat] = useState(false);

  const handleFocus = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleFocusFW = () => {
    setIsEditingFW(true);
  };

  const handleBlurFW = () => {
    setIsEditingFW(false);
  };

  const handleFocusSat = () => {
    setIsEditingSat(true);
  };

  const handleBlurSat = () => {
    setIsEditingSat(false);
  };



  return (
    <div>
      <FormControlLabel
          style={{ marginTop: "-20px", marginBottom: "10px" }}
          control={
            <Checkbox
              checked={useOriginalThreshold}
              onChange={onCheckboxChange}
            />
          }
          label={
            <span style={{ fontSize: "14px" }}>Use defaults</span>
          }
        />
      

        
        <TextField
          style={{ marginTop: "10px", marginBottom: "20px" }}
          label="Extremely High Cost per Location Threshold"
          type="text"
          variant="outlined"
          value={
            isEditing ? Math.round(inputThreshold) : `$${inputThresholdFormat}`
          }
          onChange={onThresholdChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          disabled={useOriginalThreshold}
          fullWidth
        />

      <TextField
          label="Maximum Spend on Fixed Wireless"
          style={{ marginTop: "10px", marginBottom: "20px" }}
          type="text"
          variant="outlined"
          value={
            isEditingFW ? Math.round(inputFWSpend) : `$${inputFWSpendFormat}`
          }
          onChange={onFWSpendChange}
          onFocus={handleFocusFW}
          onBlur={handleBlurFW}
          disabled={useOriginalThreshold}
          fullWidth
        />

      <TextField
          label="Fixed Cost of Satellite"
          type="text"
          variant="outlined"
          value={
            isEditingSat ? Math.round(inputSatSpend) : `$${inputSatSpendFormat}`
          }
          onChange={onSatSpendChange}
          onFocus={handleFocusSat}
          onBlur={handleBlurSat}
          disabled={useOriginalThreshold}
          fullWidth
        />


    </div>
  );
}

export default HighCostThresh;
